import { apiClient } from './client';
import { ItemFichaTecnica, Produto } from '../types';

export interface DadosProduto {
  nome: string;
  descricao?: string;
  categoria_id?: number | string;
  preco_venda?: number | string;
  imagem_base64?: string | null;
  remover_imagem?: boolean;
}

export function listarProdutos(): Promise<Produto[]> {
  return apiClient.get('/produtos').then((res) => res.data.produtos);
}

export function buscarProduto(id: number | string): Promise<Produto> {
  return apiClient.get(`/produtos/${id}`).then((res) => res.data.produto);
}

export function criarProduto(dados: DadosProduto): Promise<Produto> {
  return apiClient.post('/produtos', dados).then((res) => res.data.produto);
}

export function atualizarProduto(id: number | string, dados: DadosProduto): Promise<Produto> {
  return apiClient.put(`/produtos/${id}`, dados).then((res) => res.data.produto);
}

export function removerProduto(id: number): Promise<{ ok: boolean }> {
  return apiClient.delete(`/produtos/${id}`).then((res) => res.data);
}

export function salvarFichaTecnica(
  id: number | string,
  itens: Array<Pick<ItemFichaTecnica, 'materia_prima_id' | 'quantidade'>>
): Promise<Produto> {
  return apiClient.put(`/produtos/${id}/ficha-tecnica`, { itens }).then((res) => res.data.produto);
}
